import { Backdrop, Box, keyframes } from '@mui/material';
import { colors, radii, shadows } from '@components/design-system/tokens';

const pulse = keyframes`
    0%, 100% {
        opacity: 1;
        transform: scale(1);
    }
    50% {
        opacity: 0.7;
        transform: scale(0.95);
    }
`;

const spin = keyframes`
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
`;

interface LoadingScreenProps {
    active: boolean;
}

export const LoadingScreen = ({ active }: LoadingScreenProps) => {
    return (
        <Backdrop
            open={active}
            sx={{
                zIndex: (theme) => theme.zIndex.drawer + 1000,
                backgroundColor: 'rgba(255, 255, 255, 0.85)',
                backdropFilter: 'blur(4px)',
            }}>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 3,
                }}>
                {/* Spinner container */}
                <Box
                    sx={{
                        position: 'relative',
                        width: 64,
                        height: 64,
                    }}>
                    {/* Outer ring */}
                    <Box
                        sx={{
                            position: 'absolute',
                            inset: 0,
                            borderRadius: '50%',
                            border: `3px solid ${colors.neutral[200]}`,
                        }}
                    />
                    {/* Spinning arc */}
                    <Box
                        sx={{
                            position: 'absolute',
                            inset: 0,
                            borderRadius: '50%',
                            border: `3px solid transparent`,
                            borderTopColor: colors.primary[500],
                            animation: `${spin} 1s linear infinite`,
                        }}
                    />
                    {/* Center logo */}
                    <Box
                        sx={{
                            position: 'absolute',
                            inset: 8,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            animation: `${pulse} 2s ease-in-out infinite`,
                        }}>
                        <Box
                            component='img'
                            src='/logo.png'
                            alt=''
                            sx={{
                                width: 32,
                                height: 32,
                                objectFit: 'contain',
                            }}
                        />
                    </Box>
                </Box>
            </Box>
        </Backdrop>
    );
};
